export const SITE = {
  name: "Taidotech",
  legalName: "Taidotech Pty Ltd",
  email: "info@taidotech.com.au",
  phone: "03 4232 6950",
  phoneTel: "0342326950",
  address: {
    line1: "Office 1, Level 1",
    line2: "343 Pakington Street",
    line3: "Newtown, VIC 3220",
    line4: "Australia",
  },
  tagline: "Australian-owned. Azure-hosted. Regulated-ready.",
};
